import React from 'react';

import { useMessage } from '@tmapy/intl';
import { FormItem, Textarea } from '@tmapy/style-guide';

import { commonMessages } from '../../commonMessages';
import type { ServerErrorItem } from '../../hooks/useFormItemServerErrors';

import { serviceOrderFormMessages, serviceOrderMessages } from './serviceOrderMessages';

type ServiceOrderNoteFieldProps = {
  value: string;
  isDisabled: boolean;
  serverError?: ServerErrorItem;
  onChange(value: string): void;
};

export const ServiceOrderNoteField: React.FC<ServiceOrderNoteFieldProps> = ({
  value,
  isDisabled,
  serverError,
  onChange,
}) => {
  const formatMessage = useMessage();

  return (
    <FormItem
      label={formatMessage(serviceOrderMessages.note)}
      errorMessage={serverError?.errorMessage}
      help={formatMessage(serviceOrderFormMessages.noteHint)}
      helpLabel={formatMessage(commonMessages.formItemHelpLabel)}
    >
      <Textarea
        name='note'
        value={value}
        isDisabled={isDisabled}
        isInvalid={!!serverError?.isInvalid}
        onChange={(_e, eventData) => onChange(eventData.value)}
      />
    </FormItem>
  );
};
